import React, { useEffect, useState } from 'react';
import { Star, Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'About',
    href: '#about'
  }, {
    name: 'Videos',
    href: '#videos'
  }, {
    name: 'Gallery',
    href: '#gallery'
  }, {
    name: 'Tour Dates',
    href: '#tour'
  }];
  const handleNavClick = () => {
    setIsMobileMenuOpen(false);
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-tx-midnight/95 backdrop-blur-sm border-b border-tx-saddle py-3 shadow-lg' : 'bg-transparent py-5'}`} data-id="element-144">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-145">
        <div className="flex items-center justify-between" data-id="element-146">
          {/* Logo */}
          <a href="#hero" className="flex items-center group" onClick={handleNavClick} data-id="element-147">
            <img src="https://cdn.magicpatterns.com/uploads/fbLbfTVmSWg6eSdadq3wGK/header.svg" alt="Texarkana Band Logo" className="h-10 w-auto opacity-90 group-hover:opacity-100 transition-opacity duration-300" data-id="element-148" />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-149">
            {navLinks.map(link => <a key={link.name} href={link.href} className="font-body font-medium text-sm text-tx-parchmentLight/80 hover:text-tx-parchmentLight relative group tracking-widest uppercase" data-id="element-150">
                {link.name}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-tx-blue transition-all duration-300 group-hover:w-full" data-id="element-151"></span>
              </a>)}
            <a href="#booking" className="font-body font-medium text-sm px-5 py-2 border-2 border-tx-blue text-tx-blue hover:bg-tx-blue hover:text-white transition-all duration-300 tracking-widest uppercase" data-id="element-152">
              BOOK US
            </a>
          </nav>

          {/* Mobile Menu Toggle */}
          <button className="md:hidden text-tx-parchmentLight hover:text-tx-blue transition-colors" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-153">
            {isMobileMenuOpen ? <X className="w-8 h-8" data-id="element-154" /> : <Menu className="w-8 h-8" data-id="element-155" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav */}
      <div className={`md:hidden absolute top-full left-0 w-full bg-tx-midnight border-b border-tx-saddle transition-all duration-300 overflow-hidden ${isMobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-156">
        <nav className="flex flex-col px-4 py-6 gap-4" data-id="element-157">
          {navLinks.map(link => <a key={link.name} href={link.href} onClick={handleNavClick} className="font-body font-medium text-lg text-tx-parchmentLight hover:text-tx-blue transition-colors tracking-widest uppercase block py-2 border-b border-tx-saddle/50" data-id="element-158">
              {link.name}
            </a>)}
          <a href="#booking" onClick={handleNavClick} className="font-body font-medium text-lg text-tx-blue hover:text-tx-parchmentLight transition-colors tracking-widest uppercase block py-2 mt-2" data-id="element-159">
            BOOK US
          </a>
        </nav>
      </div>
    </header>;
}